export function guardianLanguageTarget(currentHref, fallbackHref, alternateHref) {
  const current = new URL(currentHref);
  const fallback = new URL(fallbackHref, current);
  if (fallback.origin !== current.origin) return null;
  let target = fallback;
  if (alternateHref) {
    const alternate = new URL(alternateHref, current);
    if (alternate.origin === current.origin) target = alternate;
  }
  target.search = current.search;
  target.hash = current.hash;
  return target.href;
}

function refreshGuardianLanguageLinks() {
  for (const link of document.querySelectorAll('.guardian-language-bar a[hreflang]')) {
    const locale = link.getAttribute('hreflang');
    const alternate = Array.from(document.querySelectorAll('link[rel="alternate"][hreflang]'))
      .find((item) => item.getAttribute('hreflang') === locale);
    const target = guardianLanguageTarget(window.location.href, link.getAttribute('href'), alternate?.href);
    if (target) link.href = target;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', refreshGuardianLanguageLinks, { once: true });
} else {
  refreshGuardianLanguageLinks();
}
window.addEventListener('hashchange', refreshGuardianLanguageLinks);
window.addEventListener('popstate', refreshGuardianLanguageLinks);
document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('.guardian-language-bar a[hreflang]')) {
    refreshGuardianLanguageLinks();
  }
}, true);
